import MasterLayout from 'components/layouts/MasterLayout'
import { LoadingBarProcess } from 'components/loadingProcess/LoadingBarProcess'
import React from 'react'
import { Route, Routes } from 'react-router-dom'

const HomePage = React.lazy(() => import('pages/home/HomePage'))

const HomeRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MasterLayout />}>
        <Route
          index
          element={
            <React.Suspense fallback={<LoadingBarProcess />}>
              {/* <RequireAuth> */}
                <HomePage />
              {/* </RequireAuth> */}
            </React.Suspense>
          }
        />
      </Route>
    </Routes>
  )
}

export default HomeRoutes